import { Box, Chip, Grid, IconButton, Link, Modal, Rating, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import TimeHelper from '../../../../utils/time';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import AssignmentIndRoundedIcon from '@mui/icons-material/AssignmentIndRounded';
import OpenInFullRoundedIcon from '@mui/icons-material/OpenInFullRounded';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';

function ProductCommentDetailCommentInfoRowV2({
    commentDetail,
    commentUrl,
    other_link,
    phoneNumber,
    firstLastName,
    atananKisi,
}: any) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const infoCardSx = {
        p: 2,
        borderRadius: '18px',
        border: '1px solid rgba(148, 163, 184, 0.2)',
        backgroundColor: 'rgba(255,255,255,0.88)',
        boxShadow: '0 12px 28px rgba(15, 23, 42, 0.05)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 16px 32px rgba(15, 23, 42, 0.08)',
        },
    } as const;

    const labelSx = {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        fontSize: '0.83rem',
        fontWeight: 700,
        color: '#64748b',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        mb: 0.75,
    } as const;

    const valueSx = {
        fontSize: '1rem',
        fontWeight: 700,
        color: '#0f172a',
        wordBreak: 'break-word',
    } as const;

    const shipmentLabel = (() => {
        if (commentDetail?.shipmentStateCode === 'DELIVERED') {
            return t('general.shipmentStates.delivered');
        } else if (commentDetail?.shipmentStateCode === 'CANCELED') {
            return t('general.shipmentStates.canceled');
        } else if (commentDetail?.shipmentStateCode === 'RETURNEDTOSELLER') {
            return t('general.shipmentStates.returnedToSeller');
        }

        return t('general.shipmentStates.unknown');
    })();
    const copyToClipboard = async (value: any) => {
        if (value === null || value === undefined || value === '') return;
        try {
            await navigator.clipboard.writeText(String(value));
        } catch (error) {
            console.log('Copy failed :>> ', error);
        }
    };

    const copyIconButtonSx = {
        ml: 0.5,
        color: '#64748b',
        border: '1px solid rgba(148, 163, 184, 0.2)',
        backgroundColor: '#fff',
        '&:hover': {
            backgroundColor: '#f8fafc',
            color: '#2563eb',
        },
    } as const;
    return (
        <Grid
            container
            spacing={2.5}
            sx={{
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
                mb: 3,
                p: { xs: 2.5, md: 3 },
                borderRadius: '24px',
                border: '1px solid rgba(15, 23, 42, 0.08)',
                background:
                    'linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(248,250,252,0.96) 100%)',
                boxShadow: '0 18px 40px rgba(15, 23, 42, 0.08)',
            }}
        >
            <Grid
                size={{
                    md: 3,
                    xs: 12,
                    lg: 3,
                }}
                sx={{ minWidth: 0 }}
            >
                <Box
                    sx={{
                        position: 'relative',
                        mx: 'auto',
                        maxHeight: { xs: 220, lg: 220 },
                        maxWidth: { xs: 220, lg: 220 },
                        borderRadius: '24px',
                        cursor: 'zoom-in',
                        overflow: 'hidden',
                        border: '1px solid rgba(148, 163, 184, 0.22)',
                        boxShadow: '0 18px 40px rgba(15, 23, 42, 0.16)',
                        transition: 'transform 0.25s ease, box-shadow 0.25s ease',
                        '&:hover': {
                            transform: 'translateY(-4px) scale(1.01)',
                            boxShadow: '0 24px 48px rgba(15, 23, 42, 0.22)',
                        },
                    }}
                    onClick={handleOpen}
                >
                    <img
                        style={{
                            display: 'block',
                            width: '100%',
                            maxHeight: 220,
                            maxWidth: 220,
                            objectFit: 'cover',
                        }}
                        alt=""
                        src={commentDetail?.optionImgUrl?.replace('120', '256')}
                        loading="lazy"
                    />
                    <Chip
                        icon={<OpenInFullRoundedIcon />}
                        label="Yakınlaştır"
                        size="small"
                        sx={{
                            position: 'absolute',
                            right: 12,
                            top: 12,
                            backgroundColor: 'rgba(255,255,255,0.92)',
                            fontWeight: 700,
                            boxShadow: '0 8px 18px rgba(15, 23, 42, 0.18)',
                        }}
                    />
                </Box>
                <Box sx={{ mt: 2, textAlign: 'center' }}>
                    <Tooltip title={commentUrl || ''}>
                        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, maxWidth: '100%' }}>
                            <Link
                                href={commentUrl}
                                target={'_blank'}
                                underline="hover"
                                sx={{
                                    cursor: 'pointer',
                                    fontWeight: 700,
                                    fontSize: '0.98rem',
                                }}
                            >{`${commentDetail?.specialCode} - ${commentDetail?.colorCode}`}</Link>
                            <Tooltip title="Kopyala">
                                <IconButton
                                    size="small"
                                    onClick={() =>
                                        copyToClipboard(`${commentDetail?.specialCode} - ${commentDetail?.colorCode}`)
                                    }
                                    sx={copyIconButtonSx}
                                >
                                    <ContentCopyRoundedIcon sx={{ fontSize: 16 }} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Tooltip>
                </Box>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box
                        sx={{
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            bgcolor: 'rgba(15, 23, 42, 0.92)',
                            borderRadius: '24px',
                            boxShadow: 24,
                            p: 3,
                            width: { xs: '92vw', md: '60vw', lg: '42vw' },
                            maxHeight: '90vh',
                            position: 'relative',
                        }}
                    >
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={{
                                position: 'absolute',
                                right: 18,
                                top: 18,
                                cursor: 'pointer',
                                color: '#fff',
                                backgroundColor: 'rgba(255,255,255,0.12)',
                                '&:hover': {
                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                },
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <img
                            width="100%"
                            height="auto"
                            src={commentDetail?.optionImgUrl}
                            style={{
                                maxWidth: '100%',
                                maxHeight: '80vh',
                                objectFit: 'contain',
                                borderRadius: '16px',
                            }}
                            alt="Zoomed"
                        />
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            color={'#fff'}
                            sx={{ mt: 2, fontWeight: 700 }}
                        >
                            {`${commentDetail?.specialCode} - ${commentDetail?.colorCode}`}
                        </Typography>
                    </Box>
                </Modal>
            </Grid>
            <Grid
                size={{
                    md: 5,
                    xs: 12,
                    lg: 5,
                }}
                sx={{ minWidth: 0 }}
            >
                <Box sx={infoCardSx}>
                    <Typography sx={labelSx}>
                        <StarRoundedIcon sx={{ fontSize: 18, color: '#f59e0b' }} />
                        {t('general.point')}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Rating name="read-only" value={commentDetail?.starScore} size="large" readOnly />
                        <Chip
                            label={`${commentDetail?.starScore || 0}/5`}
                            size="small"
                            sx={{ fontWeight: 700, backgroundColor: 'rgba(245, 158, 11, 0.12)', color: '#b45309' }}
                        />
                    </Box>
                </Box>
                <Box sx={{ ...infoCardSx, mt: 1.5 }}>
                    <Typography sx={labelSx}>
                        <BadgeRoundedIcon sx={{ fontSize: 18, color: '#2563eb' }} />
                        {t('general.customerId')}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                        <Link
                            target="_blank"
                            className="linktxt"
                            href={other_link + '/customerManagement?customerId=' + commentDetail?.customerId}
                            rel="noreferrer"
                            underline="hover"
                            sx={valueSx}
                        >
                            {commentDetail?.customerId}
                        </Link>
                        <Tooltip title="Kopyala">
                            <IconButton
                                size="small"
                                onClick={() => copyToClipboard(commentDetail?.customerId)}
                                sx={copyIconButtonSx}
                            >
                                <ContentCopyRoundedIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                <Box sx={{ ...infoCardSx, mt: 1.5 }}>
                    <Typography sx={labelSx}>
                        <PhoneIphoneRoundedIcon sx={{ fontSize: 18, color: '#16a34a' }} />
                        Tel.No
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                        <Typography sx={valueSx}>{phoneNumber}</Typography>
                        <Tooltip title="Kopyala">
                            <IconButton size="small" onClick={() => copyToClipboard(phoneNumber)} sx={copyIconButtonSx}>
                                <ContentCopyRoundedIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                <Box sx={{ ...infoCardSx, mt: 1.5 }}>
                    <Typography sx={labelSx}>
                        <PersonRoundedIcon sx={{ fontSize: 18, color: '#7c3aed' }} />
                        {t('general.name')} {t('general.surname')}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                        <Typography sx={valueSx}>{firstLastName}</Typography>
                        <Tooltip title="Kopyala">
                            <IconButton
                                size="small"
                                onClick={() => copyToClipboard(firstLastName)}
                                sx={copyIconButtonSx}
                            >
                                <ContentCopyRoundedIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                <Box sx={{ ...infoCardSx, mt: 1.5 }}>
                    <Typography sx={labelSx}>
                        <MailOutlineRoundedIcon sx={{ fontSize: 18, color: '#0f766e' }} />
                        {t('general.eMail')}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                        <Link
                            target="_blank"
                            className="linktxt"
                            href={other_link + '/customerManagement?customerId=' + commentDetail?.customerId}
                            rel="noreferrer"
                            underline="hover"
                            sx={valueSx}
                        >
                            {commentDetail?.userEmail}
                        </Link>
                        <Tooltip title="Kopyala">
                            <IconButton
                                size="small"
                                onClick={() => copyToClipboard(commentDetail?.userEmail)}
                                sx={copyIconButtonSx}
                            >
                                <ContentCopyRoundedIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </Grid>
            <Grid
                size={{
                    md: 4,
                    xs: 12,
                    lg: 4,
                }}
                sx={{ minWidth: 0 }}
            >
                <Box sx={infoCardSx}>
                    <Typography sx={labelSx}>
                        <CalendarMonthRoundedIcon sx={{ fontSize: 18, color: '#2563eb' }} />
                        {t('commentDetail.commentDate')}
                    </Typography>
                    <Typography sx={valueSx}>{TimeHelper.formatDate(commentDetail.commentDate)}</Typography>
                </Box>

                <Box sx={{ ...infoCardSx, mt: 1.5 }}>
                    <Typography sx={labelSx}>
                        <ReceiptLongRoundedIcon sx={{ fontSize: 18, color: '#ea580c' }} />
                        {t('general.orderSiparis')} ID
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                        <Link
                            target="_blank"
                            className="linktxt"
                            href={'/orderdetail?orderId=' + commentDetail?.orderId}
                            rel="noreferrer"
                            underline="hover"
                            sx={valueSx}
                        >
                            {commentDetail?.orderId}
                        </Link>
                        <Tooltip title="Kopyala">
                            <IconButton
                                size="small"
                                onClick={() => copyToClipboard(commentDetail?.orderId)}
                                sx={copyIconButtonSx}
                            >
                                <ContentCopyRoundedIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                <Box sx={{ ...infoCardSx, mt: 1.5 }}>
                    <Typography sx={labelSx}>
                        <LocalShippingRoundedIcon sx={{ fontSize: 18, color: '#0f766e' }} />
                        {t('general.shipping')} ID
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                        <Link
                            target="_blank"
                            className="linktxt"
                            href={other_link + '/orderdetail?orderId=' + commentDetail?.orderId}
                            rel="noreferrer"
                            underline="hover"
                            sx={valueSx}
                        >
                            {commentDetail?.shipmentId}
                        </Link>
                        <Tooltip title="Kopyala">
                            <IconButton
                                size="small"
                                onClick={() => copyToClipboard(commentDetail?.shipmentId)}
                                sx={copyIconButtonSx}
                            >
                                <ContentCopyRoundedIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                <Box sx={{ ...infoCardSx, mt: 1.5 }}>
                    <Typography sx={labelSx}>
                        <AssignmentIndRoundedIcon sx={{ fontSize: 18, color: '#7c3aed' }} />
                        {t('comments.appointedPerson')}
                    </Typography>
                    <Typography sx={valueSx}>{atananKisi}</Typography>
                </Box>
                {commentDetail?.shipmentStateCode && (
                    <Box sx={{ ...infoCardSx, mt: 1.5 }}>
                        <Typography sx={labelSx}>
                            <LocalShippingRoundedIcon sx={{ fontSize: 18, color: '#16a34a' }} />
                            {t('general.shipmentState')}
                        </Typography>
                        <Chip
                            label={shipmentLabel}
                            sx={{
                                fontWeight: 700,
                                fontSize: '0.92rem',
                                backgroundColor: 'rgba(22, 163, 74, 0.12)',
                                color: '#166534',
                            }}
                        />
                    </Box>
                )}
            </Grid>
        </Grid>
    );
}

export default ProductCommentDetailCommentInfoRowV2;
